<div class="col-md-6 offset-md-3 mt-5 display-inline-block">
  <div class="card">
    <h4 class="card-header"><i class="material-icons">key</i>{{'reset_password.title' | translate}}</h4>
    <div class="card-body">
      <lib-prod-form [fields]="fields" (onSubmitEvent)="submit($event)" [formValidators]="formValidators" [data]="data" [showToolbar]="false" #form></lib-prod-form>
      <button class="btn btn-primary" (click)="form.submit()">
        Submit
      </button>
    </div>
  </div>
</div>

